import styled from "styled-components";

export const InfoSection = ({ productTitle, productDesc }) => {
  return (
    <InfoContainer>
      <h4>{productTitle}</h4>
      <p>{productDesc}</p>
    </InfoContainer>
  );
};

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 100%;
`;
